export default __webpack_public_path__ + "pdf/otkaz.6c7a8c50.pdf";